const featureFlags = {
    FEATURE_PURCHASE_SALES_EMAILS: false,
}

export default featureFlags;
